
import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from '../state.service';
import { AlertService } from '../alert.service';
import { ToastService } from '../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';


// const ApiNurseCallRoomList = {
//   // 部屋の紐付けが実施されているか？
//   isInitialized: false,
//   // 子機リスト
//   callRoomList: [
//     {
//       "_id": "5decee1f5e5cd0e8130a4f42",
//       "contractGroup": "5dd615199206e4dae1758152",
//       "contract": "5dd616779206e4dae1758202",
//       "makerCode": "GCOMM",
//       "productCode": "cocohelpa",
//       "roomCode": "101",
//       "roomName": "101",
//       "bedNo": "1",
//       "created": "2019-12-08T15:00:00.000Z",
//       "updated": "2019-12-08T15:00:00.000Z",
//       "cdcRoomCode": "401",
//       "cdcBedNo": "02"
//   }
//   ]
// };

@Injectable()
export class ApiNurseCallService extends ApiBaseService {

  protected headers: Headers;
  protected apiName = '[ ApiNurseCallService ]';
  isLoading: boolean = true;

  // ナースコールで管理している利用者情報

  // ナースコールで管理している部屋(子機)情報を取得する
  roomList = [];

  // 呼出子機情報
  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }


  /**
   * 登録済みナースコール一覧取得API
   * @return void
   */
  list(): Promise<any> {
    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: this.apiAuthStore.url + '/api/v1/nursecallRoom/devices',
        body: {}, headers: this.headers}
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    });
  }

  async setSensorInfo(params): Promise<any> {
    this.roomList = this.roomList.map(room => {
      // if (sensor.sensorId === params.sensorId) {
      //   sensor.patientId = params.patientId;
      //   sensor.isSyncEnabled = params.isSyncEnabled;
      // }
      return room;
    })
    // return new Promise((resolve) => {
    //   return this.doPost({
    //     url: this.apiAuthStore.url + `/api/v1/sensors/${params.sensorId}`,
    //     body: params, headers: this.headers
    //   }).subscribe(response => resolve(response))
    // })
  }

  /**
   * センサーの登録
   * @param params
   */
  async create(params): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.doPost({
        url: this.apiAuthStore.url + `/api/v1/nursecallRoom/device`,
        body: params, headers: this.headers
      }).subscribe(response => resolve(response), err => reject(err))
    })
  }

  /**
   * センサー情報をまるっと更新
   * @param params
   */
  async updateAll(params): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.doPut({
        url: this.apiAuthStore.url + `/api/v1/nursecallRoom/devices`,
        body: params.body,
        headers: this.headers
      }).subscribe(response => resolve(response), err => reject(err))
    })
  }

  /**
   * センサー情報の更新
   * @param params
   */
  async update(params): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.doPut({
        url: this.apiAuthStore.url + `/api/v1/nursecallRoom/device/${params._id}`,
        body: params.body,
        headers: this.headers
      }).subscribe(response => resolve(response), err => reject(err))
    })
  }

  /**
   * センサーの削除
   * @param params
   */
  async delete(params): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.doDelete({
        url: this.apiAuthStore.url + `/api/v1/nursecallRoom/device/${params._id}`,
        headers: this.headers
      }).subscribe(response => resolve(response), err => reject(err))
    })
  }

  async getOriginalData() {
    return this.doGet({
      url: this.apiAuthStore.url + '/api/v1/nursecall/checkPatients',
      body: {}, headers: this.headers}
    ).toPromise();
  }
  async setOriginalData(params) {
    return this.doPost({
      url: this.apiAuthStore.url + '/api/v1/nursecall/setOriginalPatient',
      body: params, headers: this.headers
    }).toPromise();
  }

  async getSyncPatientList(check = false) {
    return this.doGet({
      url: this.apiAuthStore.url + `/api/v1/nursecall/syncPatientList?check=${check}`,
      body: {}, headers: this.headers}
    ).toPromise();
  }

  async getCallLogs(params = {}) {
    let queryString = this.getQueryString(params);
    let url = `${this.apiAuthStore.url}/api/v1/nursecall/logs?${queryString}`;
    return this.doGet({
      url: url,
      body: {}, headers: this.headers}
    ).toPromise();
  }

  async getDiffSyncPatientInfo() {
    let url = `${this.apiAuthStore.url}/api/v1/nursecall/diffSyncPatientInfo`;
    return this.doGet({
      url: url,
      body: {}, headers: this.headers}
    ).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-nurse-call.service.ts